import * as React from "react";
import styled from "styled-components";

const LightenBackground = styled.div`
    background-color: rgba(255, 255, 255, 0.4);
`;

export default LightenBackground;
